var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "" } },
          [
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div1" }, [_vm._v("基本配置")]),
            ]),
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div2" }, [_vm._v("职位权限管理")]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "content" },
      [
        _c("p", { staticClass: "header" }, [_vm._v("添加职位")]),
        _c(
          "el-form",
          {
            staticClass: "demo-form-inline",
            attrs: { inline: true, model: _vm.formInline },
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "职位名称" } },
              [
                _c("el-input", {
                  attrs: { maxlength: "32", placeholder: "请输入职位名称" },
                  model: {
                    value: _vm.formInline.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.formInline, "name", $$v)
                    },
                    expression: "formInline.name",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "职位编码" } },
              [
                _c("el-input", {
                  attrs: { maxlength: "32", placeholder: "请输入职位编码" },
                  model: {
                    value: _vm.formInline.code,
                    callback: function ($$v) {
                      _vm.$set(_vm.formInline, "code", $$v)
                    },
                    expression: "formInline.code",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "职位描述" } },
              [
                _c("el-input", {
                  attrs: { maxlength: "64", placeholder: "请输入职位描述" },
                  model: {
                    value: _vm.formInline.remark,
                    callback: function ($$v) {
                      _vm.$set(_vm.formInline, "remark", $$v)
                    },
                    expression: "formInline.remark",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              [
                _vm.parArray.indexOf("zwadd") != -1
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.addposition },
                      },
                      [_vm._v("添加职位")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "manage" }, [
      _c("p", { staticClass: "header" }, [_vm._v("职位管理")]),
      _c(
        "div",
        { staticClass: "table" },
        [
          _c(
            "vxe-table",
            {
              attrs: {
                align: "center",
                "keep-source": "",
                data: _vm.tableData.list,
              },
            },
            [
              _c("vxe-table-column", { attrs: { title: "序号", type: "seq" } }),
              _c("vxe-table-column", {
                attrs: {
                  field: "positionName",
                  title: "职位名称",
                  width: "200",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input", {
                          model: {
                            value: scope.row.positionName,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "positionName", $$v)
                            },
                            expression: "scope.row.positionName",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: { title: "职位编码", field: "positionCode" },
              }),
              _c("vxe-table-column", {
                attrs: { title: "职位描述", field: "remark" },
              }),
              _c("vxe-table-column", {
                attrs: { title: "职位状态", field: "statusName" },
              }),
              _c("vxe-table-column", {
                attrs: { title: "创建时间", field: "createdTime" },
              }),
              _c("vxe-table-column", {
                attrs: { title: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "optain" },
                          [
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  content: "保存",
                                  placement: "top-start",
                                },
                              },
                              [
                                _vm.parArray.indexOf("zwbc") != -1
                                  ? _c(
                                      "p",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.fixPosition(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v(" 保存 ")]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  content: "删除",
                                  placement: "top-start",
                                },
                              },
                              [
                                _vm.parArray.indexOf("zwdelect") != -1
                                  ? _c(
                                      "p",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.delect(
                                              scope.row,
                                              scope.$index
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(" 删除 ")]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm.tableData.totalNum >= 8
            ? _c("div", { staticClass: "page" }, [
                _c(
                  "div",
                  { staticClass: "block" },
                  [
                    _c("el-pagination", {
                      attrs: {
                        background: "",
                        "current-page": _vm.currentPage1,
                        "page-size": 8,
                        layout: "total, prev, pager, next",
                        "prev-text": "上一页",
                        "next-text": "下一页",
                        total: _vm.tableData.totalNum,
                      },
                      on: {
                        "current-change": _vm.handleCurrentChange,
                        "update:currentPage": function ($event) {
                          _vm.currentPage1 = $event
                        },
                        "update:current-page": function ($event) {
                          _vm.currentPage1 = $event
                        },
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }